export default __webpack_public_path__ + "vmware.ae5ee2f0.png";